<script>
import dialog2Mixin from "../mixins/dialog2";
import { authComputed } from '@store/helpers'

export default {
  mixins: [dialog2Mixin],
  data() {
    return {
      neverShowAgain: false,
    }
  },
  computed: {
    ...authComputed,
  },
  watch: {
    neverShowAgain(newValue, oldValue) {
      this.$store.dispatch('auth/setCurrentInvisibleDialogLineNotify', newValue)
    }
  },
  methods: {
    goToMember() {
      this.$router.push({
        name: 'member-info',
        query: {
          scrollToId: 'line-notify'
        }
      })
      this.dialog2MixinVisible = false
    }
  },
}
</script>
<!-- section template -->
<template>
  <el-dialog
    :visible.sync="dialog2MixinVisible"
    :custom-class="`${ $style.dialogLineNotify } isStyleBase text-center`"
    width="582px"
    append-to-body
    @closed="$Dialog2MixinOnDestroy"
  >
    <div class="dialogLineNotify__title">
      <span>現已推出 LINE Notify 通知功能，不用再擔心收不到簡訊的問題囉！</span>
      <br>
      <span>事不宜遲，趕快去綁定吧！</span>
    </div>
    <!-- <div class="dialogLineNotify__description">
      <br>即可加入好友，享受更便利的寵物服務！
    </div> -->
    <el-checkbox v-model="neverShowAgain" class="isStyleBase mb-3"> 不用再提醒我</el-checkbox>
    <BaseButton
      class="isStylePrimary isRadius isFull mb-3"
      @click="goToMember"
    >
      前往綁定
    </BaseButton>
    <BaseButton
      class="isStyleDark isOutline3 isRadius isFull"
      @click="dialog2MixinVisible = false"
    >
      關閉視窗
    </BaseButton>
  </el-dialog>
</template>
<!-- section style -->
<style lang="scss" module>
.dialogLineNotify {
  :global {
    .dialogLineNotify {
      &__title {
        margin-bottom: 2.5rem;
        font-size: 1.5rem;
        font-weight: 600;
        line-height: 1.5;
      }

      &__description {
        margin-bottom: 2.5rem;
        font-size: 0.875rem;
        line-height: 1.75;
        color: $color-gray-2;
      }
    }
  }
}
</style>
